const ru = {
  message: {
    hello: "Привет из i18n",
  },
};

export { ru };
